import feathersClient from '@feathersjs/feathers'

export let feathers = null

const init = () => {
  if (!feathers) {
    feathers = feathersClient()
  }
  return feathers
}

export default { init }
